<template>
    <search-panel mode="ver">
        <a-row :span="24" slot="search">
          <a-col>
            <a-input-search
              type='textarea'
              style="padding: 4px;"
              placeholder="请输入查询文本"
              rows="3"
              v-model="tp_keywords"
              @change="inputChange"
              id="content"/>
          </a-col>
          <a-col>
            <a>
              <a-checkbox v-if="intime" 
                @change="intimeSearch($event)" 
                :checked="true"
                style="position: absolute; top: -36px; right: 0px; z-index: 1;" 
                >
                可投项目
              </a-checkbox>
              <a-checkbox v-else="" 
                style="position: absolute; top: -36px; right: 0px; z-index: 1;" 
                @change="intimeSearch($event)">
                可投项目
              </a-checkbox>
              <a-icon type="search" style="font-size: 20px; position: absolute; top: 28px; right: 2px; z-index: 1;" @click="searchBidding()"></a-icon>
            </a>
          </a-col>
        </a-row>
        <a-row slot="filter">
          <a-row class="pb8">
            <a-col :span="24"> 
              <a-input style="padding: 4px 4px 4px 4px;" placeholder="请输入区域" v-model="tp_region" @change="inputChange"/>
            </a-col>
          </a-row>
        </a-row>
    </search-panel>
</template>

<script>
import {SearchPanel} from '@/com/Basic'

export default {
  name: 'BiddingSearch',
  data() {
    return {
      tp_keywords: this.keywords,
      tp_region: this.region,
      intime: false
    }
  },
  props: {
    postdata: {},
    keywords: {},
    region: {}
  },
  components: {
    SearchPanel
  },
  watch: {
    tp_keywords(newvalue, oldvalue) {
      this.tp_keywords = newvalue
    },
    region(newvalue, oldvalue) {
      this.tp_region = newvalue
    }
  },
  methods: {
    intimeSearch: function(e) {
      if (e.target.checked) {
        this.intime = true
      } else {
        this.intime = false
      }
    },
    inputChange: function() {
      this.$emit('inputchange', this.tp_keywords, this.tp_region);
    },
    searchBidding: function() {
      let page = 1;
      this.postdata["page"] = page
      this.postdata["from"] = (page - 1) * 20
      this.postdata["to"] = page * 20
      if (this.tp_keywords != "") {
        this.postdata["keywords"] = this.tp_keywords
      } 
      else {
        delete this.postdata["keywords"]
      }
      if (this.tp_region != "") {
        this.postdata["region"] = this.tp_region
      }
      else {
        delete this.postdata["region"]
      }
      if (this.intime) {
        this.postdata["intime"] = true
      } else {
        delete this.postdata["intime"]
      }
      this.postdata["task"] = "BID_TASK_LIST"
      this.postdata["api-path"] = "bidding"
      let that = this
      let loading = that.$message.loading("搜索中...", 0);
      that.post('bidding', that.postdata)
        .then(function(data) {
          setTimeout(loading, 0);
          that.$store.commit('updatepostdata', {post: that.postdata, tab: 'bid'});
          that.$store.commit('updateresult', {result: data.data, tab:'bid'});
          //that.$store.commit('updaterelationitem', {});
          that.$emit('search', that.postdata, data.data, {});
        }).catch(function (e) {
          console.log(e);
          setTimeout(loading, 0);
          that.$message.error("查询失败")
      })
    }
  },
  created() {
    if (this.postdata.intime) {
      this.intime = true
    }
  }
}
</script>

<style scoped>
  .pb8 {
    padding-top: 0px;
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 4px;
  }
  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }
  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
